import PropTypes from 'prop-types';
import React from 'react';

export default class Sticky extends React.Component {
  static propTypes = {
    children: PropTypes.object,
  };

  render() {
    return (
      <div className="sticky">
        <div
          className="sticky__children-container"
          ref={(node) => (this.childrenContainer = node)}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

// Bug in Chrome, where there's a gap when the address bar shrinks/grows
// https://bugs.chromium.org/p/chromium/issues/detail?id=609994#
